import { createContext } from "react";

const AnimationContext = createContext({
  colorVariant: 2,
  animation: false,
  toggleAnimation: () => {},
});

export default AnimationContext;
